import React, { useRef, useState } from "react";
import BuddibleSocket from "../../lib/BuddibleSocket";
import Utilities from "../../lib/Utilities";
import CodeList from "../../lib/CodeList";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

export default function LogiTalkLandingInquiry() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  const handleIsModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <div className="bg-light">
      <div className={`${isModalOpen ? "d-block" : "d-none"}`}>
        <InquiryModal handleIsModalOpen={handleIsModalOpen} />
      </div>
      <div className="container-xl p-5 NNS">
        <div className="d-flex flex-column align-items-center mb-3">
          <div className="BM-DH h1">
            <p className="text-secondary">
              {t("logiTalkLanding.inquiry.title")}
            </p>
            <p>
              <span className="bg-gbts text-white px-1">
                {t("logiTalkLanding.inquiry.logiTalkTalk")}
              </span>{" "}
              {t("logiTalkLanding.inquiry.description")}
            </p>
          </div>
        </div>
        <div
          className="border bg-white shadow p-3 row"
          style={{ borderRadius: 50 }}
        >
          <div className="col-12 col-md-6 border-right d-none d-md-flex flex-column align-items-center py-3">
            <div className="d-flex flex-column justify-content-center align-items-center text-center w-100">
              <span
                className="d-inline-block h4 font-weight-bold pb-2 mb-3 text-center"
                style={{ borderBottom: "5px solid #3b44ac" }}
              >
                {t("logiTalkLanding.inquiry.chatBot.title")}
              </span>
              <img
                className="rounded mb-2 w-100"
                style={{ maxWidth: 260 }}
                src="https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/E0001/hskim@bstc.kr/20221117091042_shutterstock_712414756.jpg"
                alt="자동챗봇 서버"
              />
              <p className="h5 text-left" style={{ maxWidth: 260 }}>
                {t("logiTalkLanding.inquiry.chatBot.description.1")}
                <span className="text-gbts">
                  {t("logiTalkLanding.inquiry.chatBot.description.2")}
                </span>
                {t("logiTalkLanding.inquiry.chatBot.description.3")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex d-md-none flex-column align-items-center py-3">
            <div className="d-flex flex-column justify-content-center align-items-center text-center w-100">
              <span
                className="d-inline-block h4 font-weight-bold pb-2 mb-3 text-center"
                style={{ borderBottom: "5px solid #3b44ac" }}
              >
                {t("logiTalkLanding.inquiry.chatBot.title")}
              </span>
              <img
                className="rounded mb-2 w-100"
                style={{ maxWidth: 260 }}
                src="/img/inquiryAutoChat.jpg"
                alt="자동챗봇 서버"
              />
              <p className="h5 text-left" style={{ maxWidth: 260 }}>
                {t("logiTalkLanding.inquiry.chatBot.description.1")}
                <span className="text-gbts">
                  {t("logiTalkLanding.inquiry.chatBot.description.2")}
                </span>
                {t("logiTalkLanding.inquiry.chatBot.description.3")}
              </p>
            </div>
          </div>
          <div className="col-12 col-md-6 d-flex flex-column align-items-center py-3">
            <div className="d-flex flex-column justify-content-center align-items-center text-center w-100">
              <span
                className="d-inline-block h4 font-weight-bold pb-2 mb-3 text-center"
                style={{ borderBottom: "5px solid #3b44ac" }}
              >
                {t("logiTalkLanding.inquiry.oneClick.title")}
              </span>
              <img
                className="rounded mb-2 w-100"
                style={{ maxWidth: 260 }}
                src="/img/inquiryEmploeeMatching.png"
                alt="자동챗봇 서버"
              />
              <p className="h5 text-left" style={{ maxWidth: 260 }}>
                {t("logiTalkLanding.inquiry.oneClick.description.1")}
                <span className="text-gbts">
                  {t("logiTalkLanding.inquiry.oneClick.description.2")}
                </span>
                {t("logiTalkLanding.inquiry.oneClick.description.3")}
              </p>
            </div>
          </div>
        </div>
        <div className="font-weight-bold d-flex flex-column align-items-center">
          <div className="my-5 w-100">
            <p className="h4 row m-0 p-0 mx-3 mb-2">
              <span className="col-1 m-0 p-0 text-right ">
                <i className="fa-solid fa-check text-gbts" />
              </span>
              <span className="col-11 m-0 p-0 pl-3">
                {t("logiTalkLanding.inquiry.dashboard.1")}
                <span className="font-weight-800">
                  {t("logiTalkLanding.inquiry.dashboard.2")}
                </span>{" "}
                {t("logiTalkLanding.inquiry.dashboard.3")}
              </span>
            </p>{" "}
            <p className="h4 row m-0 p-0 mx-3 mb-2">
              <span className="col-1 m-0 p-0 text-right ">
                <i className="fa-solid fa-check text-gbts" />
              </span>
              <span className="col-11 m-0 p-0 pl-3">
                {t("logiTalkLanding.inquiry.createMenu.1")}
                <span className="font-weight-800">
                  {t("logiTalkLanding.inquiry.createMenu.2")}
                </span>
              </span>
            </p>
            <p className="h4 row m-0 p-0 mx-3 mb-2">
              <span className="col-1 m-0 p-0 text-right ">
                <i className="fa-solid fa-check text-gbts" />
              </span>
              <span className="col-11 m-0 p-0 pl-3">
                {t("logiTalkLanding.inquiry.services.1")}
                <span className="font-weight-800">
                  {t("logiTalkLanding.inquiry.services.2")}
                </span>
              </span>
            </p>
          </div>
          <button
            className="btn_1 text-gbts px-5"
            onClick={() => handleIsModalOpen()}
          >
            <span className="h4 mb-0">
              {t("logiTalkLanding.inquiry.introductionInquiry")}
              <i className="fa-solid fa-arrow-right-long ml-3" />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
}

//도입문의 모달
const InquiryModal = (props) => {
  const { handleIsModalOpen } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const $controller = {
    comp_name: useRef(),
    user_name: useRef(),
    e_mail: useRef(),
    phone_num: useRef(),
    memo: useRef(),
    privacyPolicy: useRef(),
  };

  function checkValidate() {
    if (
      $controller.comp_name.current &&
      $controller.comp_name.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.enterCompanyName")
      );
      return true;
    } else if (
      $controller.user_name.current &&
      $controller.user_name.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.enterName")
      );
      return true;
    } else if (
      $controller.e_mail.current &&
      $controller.e_mail.current.value.trim() === "" &&
      $controller.phone_num.current &&
      $controller.phone_num.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.enterPhoneOrEmail")
      );
      return true;
    } else if (
      $controller.e_mail.current.value.trim() === "" &&
      $controller.phone_num.current.value.trim() === ""
    ) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.enterPhoneOrEmail")
      );
      return true;
    } else if (!util.validationEmail($controller.e_mail.current.value)) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.invalidEmail")
      );
      return true;
    } else if (
      !util.validationMobileNumber($controller.phone_num.current.value)
    ) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.invalidPhone")
      );
      return true;
    } else if (!$controller.privacyPolicy.current.checked) {
      codeList.Modal.current.alert(
        t("logiTalkLanding.inquiry.modal.checkTerms")
      );
      return true;
    }

    return false;
  }

  function requestInquiry() {
    if (checkValidate()) return;
    setIsLoading(true);
    let msgID = util.makeUUIDv4();
    let socketMsg = {
      file: "/talktalk_inquiry/JS_talktalk_inquiry_mail_send.php",
      msgID: msgID,
      data: {},
      comp_name: $controller.comp_name.current.value,
      user_name: $controller.user_name.current.value,
      e_mail: $controller.e_mail.current.value,
      phone_num: $controller.phone_num.current.value,
      memo: $controller.memo.current.value,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          codeList.Modal.current.alert(
            t("logiTalkLanding.inquiry.modal.success")
          );
        } else {
          codeList.Modal.current.alert(
            t("logiTalkLanding.inquiry.modal.error")
          );
        }
        setIsLoading(false);
      }
    });
  }

  return (
    <>
      <div className="modal_background">
        {isLoading && (
          <div
            className="position-fixed w-100 h-100 d-flex flex-column justify-content-center align-items-center"
            style={{ background: "rgba(0,0,0,0.6)", zIndex: 999 }}
          >
            <span className="h3 text-white">...Loading</span>
          </div>
        )}
        <div
          className="modal_body rounded bg-white overflow-hidden"
          style={{ maxWidth: "90vw" }}
        >
          <div className="d-flex flex-row justify-content-between align-items-center px-3 py-2">
            <p className="h4 mb-0 font-weight-bold">
              <span className="text-gbts">
                {t("logiTalkLanding.inquiry.logiTalkTalk")}
              </span>{" "}
              {t("logiTalkLanding.inquiry.modal.title")}
            </p>
            <p
              className="h3 mb-0 text-danger cursor_pointer"
              onClick={() => handleIsModalOpen()}
            >
              &times;
            </p>
          </div>
          <div
            className="border-top border-bottom p-3"
            style={{ width: 600, maxWidth: "100%" }}
          >
            <div className="mb-2 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("logiTalkLanding.inquiry.modal.companyName")}
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  ref={$controller.comp_name}
                />
              </div>
            </div>
            <div className="mb-2 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("logiTalkLanding.inquiry.modal.name")}
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  ref={$controller.user_name}
                />
              </div>
            </div>
            <div className="mb-2 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("logiTalkLanding.inquiry.modal.email")}
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  ref={$controller.e_mail}
                />
              </div>
            </div>
            <div className="mb-2 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("logiTalkLanding.inquiry.modal.phone")}
              </label>
              <div className="col-sm-9">
                <input
                  type="text"
                  className="form-control"
                  ref={$controller.phone_num}
                />
              </div>
            </div>
            <div className="mb-2 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("logiTalkLanding.inquiry.modal.memo")}
              </label>
              <div className="col-sm-9">
                <textarea
                  rows={5}
                  className="form-control"
                  ref={$controller.memo}
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-row justify-content-between p-3">
            <div className="form-group d-flex flex-row justify-content-start align-items-center text-left mr-2">
              <label className="container_check m-0 p-0 mr-3">
                <input
                  type="checkbox"
                  className="position-static"
                  ref={$controller.privacyPolicy}
                />
                <span className="checkmark" />
              </label>
              <Link
                to="/Terms/privacyPolicy"
                target="_blank"
                className="align-middle"
              >
                {t("logiTalkLanding.inquiry.modal.terms")}
              </Link>
            </div>

            <div>
              <button
                className="btn btn-sm btn-secondary mr-2"
                onClick={() => handleIsModalOpen()}
              >
                {t("logiTalkLanding.inquiry.modal.cancel")}
              </button>
              <button
                className="btn btn-sm btn-dark bg-gbts"
                onClick={() => requestInquiry()}
              >
                {t("logiTalkLanding.inquiry.modal.inquiry")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
